import {
    Configuration,
    OperatorInvocation,
    OperatorInvocationControllerApi,
    OperatorStatus,
} from "@inode/pilot-client-typescript-fetch";
import { ApplicationState } from "#store/types";
import { asyncPoll } from "#/util/asyncPoll";
import { baseCfg } from "#services/pilotService/baseCfg";

export class PilotOperatorInvocationService {
    private service: OperatorInvocationControllerApi;
    private url: string;
    private config: Configuration;
    private userId: string;

    constructor(url: string, userId: string) {
        this.url = url;
        this.userId = userId;
        this.config = new Configuration(baseCfg(url, userId));
        this.service = new OperatorInvocationControllerApi(this.config);
    }

    list(): Promise<Array<OperatorInvocation>> {
        return this.service.listOperatorInvocations({
            X_Reference_ID: this.userId,
        });
    }

    get(id: number): Promise<OperatorInvocation> {
        return asyncPoll<OperatorInvocation>(
            async () => {
                const response = await this.service.getOperatorInvocation({
                    id,
                    X_Reference_ID: this.userId,
                });
                if (response.status === OperatorStatus.IN_PROGRESS) {
                    return Promise.resolve({ done: false });
                }
                return Promise.resolve({
                    done: true,
                    data: response,
                });
            },
            1000,
            90 * 1000
        );
    }

    // private async getRepetitive(id: number, repetitions: number = 5): Promise<OperatorInvocation> {
    //     const operatorInvocation = await this.service.get({ id });
    //     if (operatorInvocation.finished) {
    //         return Promise.resolve(operatorInvocation);
    //     } else if (repetitions > 0) {
    //         await wait(1000);
    //         return await this.getRepetitive(id, repetitions--);
    //     } else {
    //         return Promise.reject(new Error("Retried too often"));
    //     }
    // }
}
